<template>
	<pre class="inside-text " v-html="content"></pre>
</template>

<script>
export default {
	name: 'declarationText',
	props: ['content'],
};
</script>

<style scoped>
pre.inside-text {
	white-space: pre-wrap; /* Since CSS 2.1 */
	white-space: -moz-pre-wrap; /* Mozilla, since 1999 */
	white-space: -pre-wrap; /* Opera 4-6 */
	white-space: -o-pre-wrap; /* Opera 7 */
	word-wrap: break-word; /* Internet Explorer 5.5+ */
}
</style>